export const filter = {
    id: "",
    name: "",
    code: "",
    state_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
